import React, { useState } from "react";
import CustomModal from "../../Modal/CustomModal";
import '.././popup.common.css'
import BorderedButton from "../../Buttons/BorderedButton";
import PrimaryButton from "../../Buttons/PrimaryButton";
import styles from "./Style.module.css";
import SwitchSlider from "../../SwitchSlider/SwitchSlider";

const CompletedBookingCanEditPopup = ({ onClose, onConfirm, isProcessing = false }) => {
	const [canEditCompletedBooking, setCanEditCompletedBooking] = useState(false);

	return (	
	<CustomModal  
		show={true} 
		onHide={onClose}
		customClassModal={styles.CompletedBookingCanEditPopupModal}
		customClassBody={styles.CompletedBookingCanEditPopupBody}
	>
		<div className={`popup ${styles.CompletedBookingCanEditPopup}`}>	
            <div className="header">
                <h2>Sales Closed </h2>
				<p>Changes made to the appointment will not be reflected in the existing sale, which has been closed.</p> 
				<p>If you need to make changes to the sale, please refund it instead.</p>

				<SwitchSlider
				labelText="I understand that this will not modify the existing sale."
				checked={canEditCompletedBooking}
				onChange={setCanEditCompletedBooking}
				customClassLabel={styles.switchContainer}
				customClassLabelText={styles.switchSliderLabel}
				/>

            </div>

            <div className="body">
                
            </div>

            <div className="footer">
                <BorderedButton 
					text="Cancel" 
					onClick={onClose} 
					disabled={isProcessing}
				/>
                <PrimaryButton
					text={isProcessing ? "Processing..." : "Edit Appointment"}
					onClick={onConfirm}
					disabled={!canEditCompletedBooking || isProcessing}
				/>
            </div>
        </div>
	</CustomModal>
	);
};

export default CompletedBookingCanEditPopup;
